var map = {
	"./at.jpg": 36604,
	"./atortho.jpg": 42204,
	"./avalanche.jpg": 28944,
	"./data-avalanche.png": 14099,
	"./esri.jpg": 4848,
	"./ffvl.png": 53093,
	"./flowcapt.png": 4035,
	"./icgc.jpg": 82737,
	"./icgcortho.jpg": 35107,
	"./ign.jpg": 37485,
	"./ignes.jpg": 98005,
	"./ignesortho.jpg": 30439,
	"./ignortho.jpg": 46143,
	"./ignslopes.jpg": 35973,
	"./nivose.png": 39181,
	"./opentopomap.jpg": 98625,
	"./protected-areas.jpg": 62536,
	"./romma.png": 69803,
	"./swisstopo.jpg": 14258,
	"./swisstopoortho.jpg": 96914,
	"./swisstoposlopes.jpg": 96386,
	"./winter-route.png": 52372,
	"./yeti-extent.jpg": 13027,
	"./yeti-risk.jpg": 57662
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13127;